// extracted by mini-css-extract-plugin
export default {"container":"Yviw7","label":"iu_6v","labelWithEntries":"BAdvf","entries":"I51VW","visibleEntries":"GB1Ne"};